export default __webpack_public_path__ + "static/media/Bulk-Enquiries.5d80c9ae.jpg";